//LIBRARIES
import styled, { css } from "styled-components";
import Button from "@mui/material/Button";

//MISC
import { COLORS, FONTS } from "constants/styleVariables";

export const MainButton = styled(Button)(
  ({ width }) => css`
    &.MuiButtonBase-root {
      width: 320px;
      height: 60px;
      background: #E65847;
      border-radius: 24px;
      &:hover {
        background-color: #E65847;
      }
    }
  `
);

export const SecondaryButton = styled(Button)(
  ({ isCancel }) => css`
    &.MuiButtonBase-root {
      width: 170px;
      height: 40px;
      background: #E65847};
      border-radius: 16px;
      &:hover {
        background-color: #E65847;
      }
    }
  `
);

export const IconButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    
    height: 40px;
    border-radius: 16px;
    background-color: #EBEBEB;
    &:hover {
      background-color: #293462;
    }
    margin-left: 10px;
    margin-right: 10px;
`

export const DeleteIconButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 16px;
    background-color: #EBEBEB;
    &:hover {
      background-color: #FF4D4D;
    }
    margin-left: 10px;
    margin-right: 10px;
`

export const IconImage = styled.img`
`

export const SecondaryButtonCancel = styled(Button)(
  ({ isCancel }) => css`
    &.MuiButtonBase-root {
      width: 170px;
      height: 40px;
      background: #EBEBEB;
      border-radius: 16px;
      &:hover {
        background-color: #EBEBEB
      }
    }
  `
);

export const NewButtonAtomText = styled.p`
  font-weight: 600;
  font-size: 16px;
  color: #F5F5F5;
  font-family: ${FONTS.poppins};
`;

export const CancelButtonAtomText = styled.p`
  font-weight: 600;
  font-size: 16px;
  color: #FF4D4D;
  font-family: ${FONTS.poppins};
`;

export const InactiveButtonAtomText = styled.p`
  
`;

export const InactiveButtonCancel = styled(Button)(
  ({ isCancel }) => css`
    &.MuiButtonBase-root {
      width: 170px;
      height: 40px;
      background: #EBEBEB;
      border-radius: 16px;
      font-weight: 600;
      font-size: 16px;
      color: #1D1D26;
      font-family: ${FONTS.poppins};
      &:hover {
        color: #E65847
      }
    }
  `
);


